<template>
   <div>
     <b-list-group>
       <template v-for="(item, index) in tree">
          <b-list-group-item v-if="item.Visible" :key="`root${index}`" button @click="item.Expanded = !item.Expanded; ShowCategory(item)">{{item.Name}}</b-list-group-item>
          <template v-if="item.Expanded">
            <template v-for="(child, ci) in item.Items">
              <b-list-group-item v-if="child.Visible" :key="`root${index}-Child${ci}`" button @click="Nav(item, child)"><span class="ml-4">{{child.Name}}</span></b-list-group-item>
            </template>
          </template>
        </template>
     </b-list-group>
   </div>
</template>

<script>

import ConfigService from "@/services/ConfigService";

export default {
  name: "CategoryTree",
  props: {
    currentCategory: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      tree: null
    };
  },
  created() {
    ConfigService.GetCatalog().then(c => this.tree = this.BuildTreeFromCatalog(c));
  },
  watch: {
    currentCategory(val, old) {
      if(val != old) {
        _.forEach(this.tree, i => {
          i.Expanded = (val && _.toUpper(val) === _.toUpper(i.Name));
        });
      }
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
  },
  methods: {
    BuildTreeFromCatalog(catalog){
      return _.map(catalog, i => {
        let expanded = false;

        if(this.currentCategory && _.toUpper(this.currentCategory) === _.toUpper(i.Name)){
          expanded = true;
        }

        var result = {
          ...i,
          Expanded: expanded
        }
        return result;
      })
    },
    ShowCategory(item) {
      this.$router.push({ name: "Category", params: { category: item.Name } });
    },
    Nav(root, child) {
      this.$router.push({ name: "CategorySubCategory", params: { category: root.Name, subcategory: child.Name } });
    },
    // SearchProductByTag(tag) {
    //   var query = "";
    //   if (this.userInfo) {
    //     query = "[ProductService.Tags][Name = '" + tag + "']";
    //   } else {
    //     query = "[Tags][Name = '" + tag + "']";
    //   }
    //   this.$router.push({ path: "/Products", query: { q: query } });
    // }
  },
  components: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Nav/CategoryTree.vue